<template>
  <div>
    <DoctorDashboardCard v-if="show">
      <template v-slot:title>
        <h3>
          Adhérents ayant demandé une relecture de leur défi SMART
          <v-chip v-if="hasPatients"
                  class="red">{{nbPatients}}
          </v-chip>
        </h3>
      </template>
      <template v-slot:text>
        <v-list v-if="hasPatients"
                two-line>
          <template v-for="(event, index) in events">
            <span :key="index">
              <span>
                <span>{{event.patient.first_name}} {{event.patient.last_name}} (demande créée le {{event.demande.created_at | moment('L à LT')}})</span>
              </span>

              <span>
                <v-btn icon
                       ripple
                       @click="() => { dialog.show = true; dialog.event = event; dialog.newDefi = event.demande.mission.data.quiz.defiT; }">
                  <v-icon color="primary">arrow_forward</v-icon>
                </v-btn>
              </span>

            </span>
            <v-divider v-if="index + 1 < nbPatients"></v-divider>
          </template>
        </v-list>
        <h2 v-else
            class="text-center pb-5"
            style="color: #757575">Aucun adhérent en attente.</h2>
      </template>
      <template v-slot:info-text>
        Adhérent rencontrant des difficultés a remplir leur défi SMART et ayant demandé de l'aide.
      </template>
    </DoctorDashboardCard>
    <IriadeSettingsDialog :show="dialog.show"
                          v-if="dialog.event.patient.id">
      <v-card>
        <v-card-title class="headline primary white--text"
                      style="display: flex; justify-content: space-between; position: sticky; top: 0px; z-index: 10;">
          <span>{{dialog.event.patient.first_name}} {{dialog.event.patient.last_name}} - valider la mission</span>
          <span class="pointer"
                @click="closeDialog">X</span>
        </v-card-title>
        <v-card-text>
          <MangoCaption class="mt-5"><b>Contexte</b> : Cet adhérent a demandé de l'aide pour corriger ou valider son défi SMART
          </MangoCaption>
          <MangoCaption class="mt-5"><b>Instructions</b> : Pour réaliser cette mission, vous devez :
            <ol>
              <li>Corriger le défi SMART de l'adhérent. Vous pouvez aussi le contacter.</li>
              <li>Insérer un commentaire si nécessaire</li>
              <li>VALIDER la mission</li>
            </ol>
          </MangoCaption>
          <router-link :to="{name: 'patients@find', params: {patient_id: dialog.event.patient.id, moduleName: 'suivi'}}" target="_blank"><h3 style="text-align: center">{{dialog.event.patient.first_name}} {{dialog.event.patient.last_name}}</h3></router-link>
          <div style="display: flex; flex-direction: row; justify-content: space-around" class="mt-4 mb-8">
            <div style="display: flex; flex-direction: column;">
              <p>Consulter le rapport du patient</p>
              <router-link :to="{name: 'doctors@report', params: {report_id: (dialog.event.report_id !== null) ? dialog.event.report_id.id : null}}" target='_blank'
                           :disabled="dialog.event.report_id === null"
                           class="mx-auto">
                <IriadeButton class="mb-3"
                              style="max-width: 50px; margin: 0 auto">
                  <v-icon>assignment</v-icon>
                </IriadeButton>
              </router-link>
            </div>
          </div>
          <div style="display: flex; justify-content: space-around"
               class="mt-4 mb-8">
            <div style="display: flex; flex-direction: column;">
              <p>Contacter le patient par messagerie</p>
              <router-link
                :to="{name: 'patients@find', params: {patient_id: dialog.event.patient.id, moduleName: 'messagerie'}}"
                target="_blank" class="mx-auto">
                <IriadeButton class="mb-3"
                              style="max-width: 50px; margin: 0 auto">
                  <v-icon>mail</v-icon>
                </IriadeButton>
              </router-link>
            </div>
            <div style="display: flex; flex-direction: column">
              <p>Contacter le patient par téléphone</p>
              <IriadeButton class="mb-3"
                            style="max-width: 50px; margin: 0 auto"
                            :href="`tel:${dialog.event.patient.user.phone_number}`">
                <v-icon>phone</v-icon>
              </IriadeButton>
              <span style="margin: 0 auto">{{spacedPhoneNumber}}</span>
            </div>
          </div>
          <div class="mb-5">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Historique des demandes d'aide de cet adhérent ({{dialog.event.historique.length}})</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-for="(historique, index_h) in dialog.event.historique">Mission « {{historique.mission.module.label}} », par {{historique.doctor.first_name}} {{historique.doctor.last_name}} le {{historique.created_at | moment('L')}}</div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <p>Mission SMART à relire : {{dialog.event.demande.mission.module.label}}</p>

          <p>Défi SMART rédigé par l'adhérent : {{dialog.event.demande.mission.data.quiz.defiT}}</p>

          <IriadeTextarea label="Nouveau défi SMART"
                          v-model="dialog.newDefi"></IriadeTextarea>

          <p>Commentaires à destination de l'adhérent pour expliquer son nouveau défi</p>
          <IriadeTextarea label="Commentaires"
                          v-model="dialog.comments"></IriadeTextarea>
        </v-card-text>
        <v-card-actions>
          <v-btn block
                 class="primary"
                 :loading="dialog.loading"
                 @click="setSeen">Valider la mission
          </v-btn>
        </v-card-actions>
      </v-card>
    </IriadeSettingsDialog>
  </div>
</template>

<script>
import api from 'api'
import DoctorDashboardCard from 'components/Iriade/DoctorDashboardCard'
import {chunk} from 'helpers'
import Vue from 'vue'

export default {
  components: {DoctorDashboardCard},

  computed: {
    spacedPhoneNumber() {
      if (this.dialog.event.patient.user === undefined) {
        return "";
      }
      return chunk(this.dialog.event.patient.user.phone_number, 2).join(' ')
    },

    hasPatients() {
      return this.nbPatients > 0;
    }
  },

  data: () => ({
    nbPatients: false,
    events: [],
    show: false,
    dialog: {
      show: false,
      loading: false,
      event: {
        alert: {},
        patient: {}
      },
      comments: null,
      newDefi: null,
    }
  }),

  methods: {
    closeDialog() {
      this.dialog.show = false;
      this.dialog.checkbox = false;
      this.dialog.comments = null;
      this.dialog.contact = null;
      this.dialog.cloture = null;
      this.dialog.event = {
        alert: {},
        patient: {},
      };
    },

    refresh() {
      api.get(`dashboard/modules/find`, {params: {class_name: this.module.class_name}})
        .then(res => {
          this.events = res.data.events;
          this.show = res.data.show;
          this.nbPatients = res.data.nb_events;
        })
    },

    setSeen() {
      this.dialog.loading = true;

      api.put(`salutance/patient/demande/${this.dialog.event.demande.id}`, {comments: this.dialog.comments, newDefi: this.dialog.newDefi}).then(_ => {
        this.refresh();
        this.dialog.loading = false;
        this.$mango.snackbar({
          color: 'success',
          text: "Mission validée. Bravo !"
        });
        this.closeDialog();
      })
      .catch(_ => {
        this.dialog.loading = false;
        this.$mango.snackbar({
          color: 'error',
          text: "Une erreur est survenue."
        });
      });
    }
  },

  mounted() {
    this.refresh()
  },

  props: ['module']
}
</script>
